// Copyright 2021-2026 - Hewlett Packard Enterprise Company

import { WebStorageStateStore } from 'oidc-client';

export const GLP_OIDC_AUTHORITY = window.indigo.REACT_APP_GLP_OIDC_AUTHORITY;
export const OIDC_AUTHORITY = window.indigo.REACT_APP_OIDC_AUTHORITY;
export const OIDC_CLIENT_ID = window.indigo.REACT_APP_CCS_APP_INSTANCE_ID;
export const POST_LOGOUT_URL = window.indigo.REACT_APP_CCS_LOGOUT;
export const DEV_AUTHORITY_URL = 'https://demo.duendesoftware.com';

export const LOG_LEVEL = window.indigo.REACT_APP_OIDC_LOG_LEVEL;
export const LOG_LEVELS = ['NONE', 'ERROR', 'WARN', 'INFO', 'DEBUG'];

const url = `${window.location.protocol}//${window.location.host}`;

export const COM_STORAGE_KEY_PREFIX = `com:${OIDC_CLIENT_ID}`;
export const CUSTOMER_ID_KEY = `${COM_STORAGE_KEY_PREFIX}:cid`;
export const TENANT_ACID_KEY = `${COM_STORAGE_KEY_PREFIX}:tenantAcid`;
export const DEV_ACID_KEY = `${COM_STORAGE_KEY_PREFIX}:devAcid`;
export const REDIRECT_URI_KEY = `${COM_STORAGE_KEY_PREFIX}:redirect-uri`;
export const REDIRECT_SEARCH_PARAMS_KEY = `${COM_STORAGE_KEY_PREFIX}:redirect-search-params`;
export const WHATS_NEW_MODAL_CLOSED_KEY = `${COM_STORAGE_KEY_PREFIX}:whats-new-modal-closed`;
export const WORKSPACE_ID_KEY = `${COM_STORAGE_KEY_PREFIX}:workspace-id`;
export const EMAIL_LINK_TENANT_KEY = `${COM_STORAGE_KEY_PREFIX}:email-link-tenant`;
export const COM_TAB_MARKER_PREFIX = 'COM - ';

export const getWhatsNewModalDismissedKey = cid =>
  `${COM_STORAGE_KEY_PREFIX}:${cid}:whats-new-modal-dismissed`;

export function getAuthority(workspaceId) {
  const authority = workspaceId
    ? `${GLP_OIDC_AUTHORITY}/${workspaceId}`
    : OIDC_AUTHORITY;
  return authority;
}

export function getOidcConfig(workspaceId) {
  const authority = getAuthority(workspaceId);
  const oidcConfig = {
    authority,
    client_id: OIDC_CLIENT_ID,
    redirect_uri: `${url}/auth`,
    response_type: 'code',
    post_logout_redirect_uri: POST_LOGOUT_URL,
    scope: 'openid profile email',
    silent_redirect_uri: `${url}/auth`,
    automaticSilentRenew: false,
    accessTokenExpiringNotificationTime: 300,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    metadataSeed: {
      end_session_endpoint: `${authority}/logout`,
    },
  };
  return oidcConfig;
}
